import { useDispatch, useSelector } from "react-redux";
import useAxiosClient from "../../../../hooks/useAxiosClient";
import { toast } from "react-toastify";
import { TRootState } from "../../../../store";
import moment from "moment";
import { setBenPayoutOtp, setPayoutClick, setRefId, setRefreshGetAll } from "../bloc/beneficiariesSlice";

const usePayout = () => {

    const dispatch = useDispatch();

    const { handlePostCall } = useAxiosClient();

    const { adminId, selectedBeneficiary, payout, refId } = useSelector((state: TRootState) => ({
        adminId: state.auth.adminId,
        selectedBeneficiary: state.beneficiary.selectedBeneficiary,
        payout: state.payout.payout,
        refId: state.beneficiary.refId
    }));

    const validateAddPayout = () => {
        if (!payout.pmtType) {
            toast.error("Please select payment type");
            return false;
        }

        if (!payout.amountPaid) {
            toast.error("Please enter amount paid");
            return false;
        }

        if (!payout.pmtMode) {
            toast.error("Please select payment mode");
            return false;
        }

        return true;
    };

    const onSubmitPayout = () => {
        let apiParams = {
            adminId: adminId,
            traderId: 0,
            tradeId: 0,
            amount: payout?.amountPaid,
            currency: '',
            mode: payout?.pmtMode,
            date: moment().format("YYYY-MM-DD"),
            comments: payout?.comments,
            fees: 0.1,
            tax: 0.1,
            notes: {
                notes_key_1: '',
                notes_key_2: ''
            },
            bankName: selectedBeneficiary?.bank,
            accHolder: selectedBeneficiary?.actHolder,
            ifscCode: selectedBeneficiary?.ifsc,
            emailId: selectedBeneficiary?.email,
            mobile: selectedBeneficiary?.mobile,
            uniqueUUID: Math.floor(1000 + Math.random() * 9000),
            account_number: selectedBeneficiary?.actNum,
            fund_account_id: selectedBeneficiary?.rzpFa,
            purpose: '',
            queue_if_low_balance: true,
            reference_id: refId,
            pmtType: payout?.pmtType,
            refId: payout?.referenceId
        };
        handlePostCall({
            URL: `payments/payouts/tp-payouts`,
            apiParams: apiParams,
        })
            .then(({ data, status }) => {
                toast.success(status.description);
                dispatch(setPayoutClick(false));
                dispatch(setRefreshGetAll());
                dispatch(setBenPayoutOtp(0));
                dispatch(setRefId(''));
            })
            .catch((err: any) => {
                toast.error(err);
            })
    };

    return {
        validateAddPayout,
        onSubmitPayout
    }
}
export default usePayout;